<template>
    <div v-if="newsList.length>0">
      <div class="new-newsList bot">
        <div class="card">
          <p>赛事资讯 <span @click="goNews">更多</span></p>
        </div>
      </div>
      <div class="new-list">
        <div class="item" v-for="item in newsList" :key="item.id" @click="goDetail(item.id)">
          <img :src="filterImage(item.poster, 118, 80)">
          <div class="new-left-content">
            <p class="overflow-text-two">{{ item.title }}</p>
            <div class="new-newsList-bottom">{{ item.source }}&nbsp;&nbsp;&nbsp;{{ item.topicCount }}评论&nbsp;&nbsp;&nbsp;{{ filterDate(item.publishDate, 'MM/DD') }}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
import Moment from 'moment'

export default {
  props: {
    newsList: {
      typeof: Array,
      default: () => []
    },
    match: {
      typeof: Object,
      default: {}
    },
  },
  data() {
      return {

      };
  },
  methods: {
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    filterDate(date) {
      return Moment(date).format('MM/DD')
    },
    goNews() {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/news-list?matchId=${this.match.id}`
      } else {
        window.location.href = `https://www.snsports.cn/webapp/main.html#/news-list?matchId=${this.match.id}`
      }
    },
    goDetail(id) {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/news-detail?newsId=${id}`
      } else {
        window.location.href = `https://www.snsports.cn/webapp/main.html#/news-detail?newsId=${id}`
      }
    }
  },
};
</script>

<style scoped lang="scss">
.new-newsList{
    margin-top: 10px;
    .card{
      padding: 12px 20px;
      background-color: #fff;
      margin-bottom: 1px;
      p{
        margin: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
          color: rgb(171, 171, 171);
          font-size: 12px;
        }
      }
    }
}
.new-list{
  background-color: #fff;
  padding-bottom: 10px;
  .item{
    display: flex;
    padding: 0px 20px;
    padding-top: 10px;
    img{
      width: 118px;
      height: 80px;
      margin-right: 10px;
    }
    .new-left-content{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p{
        font-size: 14px;
        color: #000;
      }
      font-size: 12px;
      color: #9B9B9B;
    }
  }
}
.bot{
  border-bottom: 2.5px solid #F8F8F8;
}
</style>
